import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/crt/admin/')({
  loader: () => {
    throw redirect({
      to: '/',
    })
  },
})
